import {getFloorById, useAppSelector} from '@lib/store';
import {isDeskReservation, WorkspaceReservation} from '@lib/store/src/data/timeslots/apiTypes';
import {MapPreviewWithSuggestionsCard} from '../../MapPreviewWithSuggestionsCard';
import {Attendee} from '@lib/store/src/data/timeslots/selectors/getAttendeeOverview';

export const MapPreviewCard = ({
  workspaceReservation,
  members,
  onClick,
}: {
  workspaceReservation: WorkspaceReservation;
  members: Array<Attendee>;
  onClick: () => void;
}) => {
  const floorId = 'floorId' in workspaceReservation.workspace ? workspaceReservation.workspace.floorId : null;
  const areaId = 'areaId' in workspaceReservation.workspace ? workspaceReservation.workspace.areaId : null;

  const mapAvailable = useAppSelector((state) => {
    if (!floorId) return false;

    const floor = getFloorById(state, floorId);
    if (!floor) {
      console.warn('Warning: reservation found for a floor that is not available in store');
      return false;
    }

    return floor.hasMap;
  });

  if (!areaId || !floorId || !mapAvailable) return null;

  const memberReservations = members.map((m) => m.reservation);
  const deskReservations = memberReservations.filter(isDeskReservation);
  const deskNames = deskReservations.map((r) => r.workspace.deskName);
  const currentDeskIds = deskReservations.map((r) => r.workspace.deskId);
  const groupSize = members.length;

  return (
    <MapPreviewWithSuggestionsCard
      buildingId={workspaceReservation.workspace.buildingId}
      floorId={floorId}
      areaId={areaId}
      deskIds={currentDeskIds}
      groupSize={groupSize}
      deskNames={deskNames}
      onClick={onClick}
    />
  );
};
